import { FieldError } from "event-definitions"
import { useEffect, useMemo } from "react"
import { useBoundContext } from "../../../binding/use-bound-context"
import { ExtendedSelectErrorChecker } from "slot-definitions"

export const FIELD_ERROR_INVALID_SELECTION = "invalidSelection"

ExtendedSelectErrorChecker.plug(<InvalidSelectionFieldError />)

export function InvalidSelectionFieldError() {
    const { label, hasSelectedValue, multiple, options, extraOptions, selectedOption, selectId } = useBoundContext()

    const validSelectedValue = useMemo(() => {
        if (!hasSelectedValue) return true

        const extraOptionsArray = Object.values(extraOptions || {}).flat()
        const allOptions = [...options, ...extraOptionsArray]

        if (multiple) {
            return selectedOption.every((selected) => allOptions.some((option) => option.name === selected))
        }

        return allOptions.some((option) => option.name === selectedOption)
    }, [hasSelectedValue, extraOptions, options, multiple, selectedOption])

    useEffect(() => {
        const eventPayload = { id: selectId, field: label, errorType: FIELD_ERROR_INVALID_SELECTION }

        if (!validSelectedValue) {
            FieldError(selectId)(FIELD_ERROR_INVALID_SELECTION).raise({
                ...eventPayload,
                error: true,
            })
        }

        return () =>
            FieldError(selectId)(FIELD_ERROR_INVALID_SELECTION).raise({
                ...eventPayload,
                error: false,
            })
    }, [selectId, label, validSelectedValue])
}
